/** @format */
import { Component, DestroyRef, EventEmitter, inject, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl } from '@angular/forms';
import { OpenUniversityCart, OpenUniversityProduct, OtmId } from 'common-typescript/types';
import * as _ from 'lodash-es';
import { Subject } from 'rxjs';
import { AppErrorHandler, FeatureToggleService, OpenUniversityProductEntityService } from 'sis-components';
import { CartPaymentType } from '../constants';

@Component({
    selector: 'app-cart-check-selections',
    templateUrl: './cart-check-selections.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class CartCheckSelectionsComponent implements OnInit {
    private readonly destroyRef = inject(DestroyRef);
    private readonly featureToggleService = inject(FeatureToggleService);
    private readonly openUniversityProductEntityService = inject(OpenUniversityProductEntityService);
    private readonly appErrorHandler = inject(AppErrorHandler);

    @Input() cart: OpenUniversityCart;
    @Input() checkEnrolments$: Subject<void>;
    @Output() hasValidEnrolments = new EventEmitter<void>();
    @Output() paymentTypeChange = new EventEmitter<CartPaymentType>();

    readonly paymentTypeControl = new FormControl<CartPaymentType>('MONETARY_PAYMENT', { nonNullable: true });
    readonly isStudyVoucherPaymentEnabled$ = this.featureToggleService.isStudyVoucherPaymentEnabled();
    totalCredits = 0;

    get cartHasNoFreeItems(): boolean {
        return !!this.cart?.items?.length && this.cart.items.every(item => item.price !== 'EUR 0.00');
    }

    ngOnInit(): void {
        this.paymentTypeControl.valueChanges
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(value => this.paymentTypeChange.emit(value));
        this.loadTotalCredits();
    }

    private loadTotalCredits(): void {
        if (!this.cart?.items?.length) return;
        const productIds: OtmId[] = _.uniq(this.cart.items.map(item => item.openUniversityProductId));
        this.openUniversityProductEntityService
            .getByIds(productIds)
            .pipe(takeUntilDestroyed(this.destroyRef), this.appErrorHandler.defaultErrorHandler())
            .subscribe((products: OpenUniversityProduct[]) => {
                this.totalCredits = this.cart.items.reduce((sum, item) => {
                    const product = products.find(p => p.id === item.openUniversityProductId);
                    return sum + (product?.credits ?? 0);
                }, 0);
            });
    }
}
